export const TYPES = {
  RESET_PANDA_DATA: 'RESET_PANDA_DATA',
  CAL_DATE_CHANGED: 'CAL_DATE_CHANGED',
};

export const resetPandaData = () => ({
  type: TYPES.RESET_PANDA_DATA,
});



/** WEBPACK FOOTER **
 ** ./src/redux/actions/pandaActions.js
 **/